import classNames from 'classnames';
import React from 'react';
import styles from './loading_dots.css';

export function LoadingDots({
  aspectRatio,
  color = 'black',
}: {
  aspectRatio?: number;
  color?: 'black' | 'inherit';
}) {
  return (
    <div
      className={classNames(styles.dots, styles[color])}
      style={{ aspectRatio }}
    >
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  );
}
